import Axios from "axios";
import {
    SET_SALARY_PAYMENT_LIST,
    UNSET_SALARY_PAYMENT_LIST,
    SET_EDITING_SALARY_PAYMENT,
    UNSET_EDITING_SALARY_PAYMENT,
} from "@/store/mutation-types";

import { saveUpdateSalaryPayment, getSalaryPaymentList, getSalaryPaymentById } from "@/store/api";

const state = {
    getSalaryPaymentList: [],
    getEditingSalaryPayment: null,
};

const getters = {
    getSalaryPaymentList(state) {
        return state.getSalaryPaymentList;
    },
    getEditingSalaryPayment(state) {
        return state.getEditingSalaryPayment;
    },
};

const mutations = {
    [SET_SALARY_PAYMENT_LIST](state, data) {
        state.getSalaryPaymentList = data;
    },
    [UNSET_SALARY_PAYMENT_LIST](state) {
        state.getSalaryPaymentList = [];
    },
    
    [SET_EDITING_SALARY_PAYMENT](state, data) {
        state.getEditingSalaryPayment = data;
    },
    [UNSET_EDITING_SALARY_PAYMENT](state) {
        state.getEditingSalaryPayment = null;
    },
};

const actions = {
    saveUpdateSalaryPayment({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalaryPayment, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalaryPaymentList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalaryPaymentList, { params: data})
                .then(function (response) {
                    commit('SET_SALARY_PAYMENT_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_SALARY_PAYMENT_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getSalaryPaymentById({ commit }, data) {
        const getSalaryPaymentRecordById = `${getSalaryPaymentById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getSalaryPaymentRecordById)
                .then((response) => {
                    resolve(response.data.data); 
                })
                .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
